/*
 * PUNCH BACK TO TOP — ADAPTIVE BACKGROUND DETECTION
 * Additive only. Does not replace the existing scroll-to-top behaviour.
 */

(() => {
  'use strict';

  const BUTTON_SELECTOR = '.pw-btt';

  function parseRgb(value) {
    if (!value || value === 'transparent') return null;

    const match = value.match(/rgba?\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)(?:\s*,\s*([\d.]+))?\s*\)/i);
    if (!match) return null;

    const alpha = match[4] === undefined ? 1 : Number(match[4]);
    if (alpha <= 0.05) return null;

    return {
      r: Number(match[1]),
      g: Number(match[2]),
      b: Number(match[3]),
      a: alpha
    };
  }

  function luminance({ r, g, b }) {
    const channels = [r, g, b].map(v => {
      v /= 255;
      return v <= 0.03928
        ? v / 12.92
        : Math.pow((v + 0.055) / 1.055, 2.4);
    });

    return 0.2126 * channels[0] +
           0.7152 * channels[1] +
           0.0722 * channels[2];
  }

  function findBackgroundColour(node) {
    let el = node;

    while (el && el !== document.documentElement) {
      const style = getComputedStyle(el);

      const rgb = parseRgb(style.backgroundColor);
      if (rgb) return rgb;

      el = el.parentElement;
    }

    /* Default page background is white. */
    return { r: 255, g: 255, b: 255, a: 1 };
  }

  function updateButton(button) {
    if (!(button instanceof Element)) return;

    const rect = button.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    const x = Math.min(
      window.innerWidth - 1,
      Math.max(0, rect.left + rect.width / 2)
    );

    const y = Math.min(
      window.innerHeight - 1,
      Math.max(0, rect.top + rect.height / 2)
    );

    const stack = document.elementsFromPoint(x, y);
    const underneath = stack.find(el =>
      el !== button &&
      !button.contains(el) &&
      !el.closest?.(BUTTON_SELECTOR)
    );

    const rgb = findBackgroundColour(underneath || document.body);
    const isDark = luminance(rgb) < 0.42;

    button.classList.toggle('pw-btt--on-dark', isDark);
    button.classList.toggle('pw-btt--on-light', !isDark);
  }

  function updateAll() {
    document.querySelectorAll(BUTTON_SELECTOR).forEach(updateButton);
  }

  let ticking = false;

  function requestUpdate() {
    if (ticking) return;
    ticking = true;

    requestAnimationFrame(() => {
      updateAll();
      ticking = false;
    });
  }

  document.addEventListener('DOMContentLoaded', requestUpdate, { once: true });
  window.addEventListener('load', requestUpdate, { once: true });
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });

  const observer = new MutationObserver(requestUpdate);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style']
  });

  requestUpdate();
})();
